export type Grade = 'K' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '10' | '11' | '12';
export const DOWNLOAD_TICKETS_MAX_TICKET_COUNT = 2000;

export const isDownloadableTicketCount = (ticketCount: number) =>
  0 < ticketCount && ticketCount <= DOWNLOAD_TICKETS_MAX_TICKET_COUNT;
